import { checkOverlap } from '@/pages/authenPages/Product/utils';
import { t } from 'i18next';
import { YupString, INVALID_FIELDS } from './general';
import * as Yup from 'yup';

export const createSubProductSchema = Yup.object().shape({
  name: YupString,
  description: YupString.max(2048),
  expiry: Yup.date().nullable(),
  batch: YupString,
  currency: YupString,
  priceRange: Yup.array()
    .of(
      Yup.object().shape({
        quantityFrom: Yup.number()
          .required(INVALID_FIELDS.REQUIRED)
          .min(1, ({ min }) => t(INVALID_FIELDS.MIN_NUMBER, { number: min })),
        quantityTo: Yup.number()
          .min(
            Yup.ref('quantityFrom'),
            ({ min }) =>
              min > 0 && t(INVALID_FIELDS.MIN_NUMBER, { number: min }),
          )
          .nullable(),
        price: Yup.number()
          .required(INVALID_FIELDS.REQUIRED)
          .min(0, ({ min }) => t(INVALID_FIELDS.MIN_NUMBER, { number: min })),
      }),
    )
    .test(
      'no-overlapping-ranges',
      INVALID_FIELDS.OVERLAP_PRICE_RANGE,
      function (value) {
        if (!value || value.length < 2) return true; // Skip if empty or single entry
        return !checkOverlap(value);
      },
    )
    .notRequired(),
  projectIds: Yup.array().of(YupString).min(1, INVALID_FIELDS.REQUIRED),
});
